<template>
        <div class="columns is-gapless main-app is-vcentered">
            <div class="column is-half has-text-right has-text-left-mobile mx-4" >
                <h1 class="title is-massive">Someone Driving like a $_&amp;*?!</h1>
                <h2 class="subtitle is-uppercase is-4 has-text-weight-bold mt-1">Invite them to the club</h2>
            </div>

            <number-plate-form></number-plate-form>    
        </div>
        
</template>

<script>
import NumberPlateForm from "../components/NumberPlateForm"
export default {
    components: { NumberPlateForm, },
}
</script>

<style lang="css" scoped>
    .title.is-massive { 
        font-size: 4rem;
        font-family: 'Open Sans', serif;
        font-kerning: normal;
        letter-spacing: -0.05em;
        line-height: 3.9rem;
    }

    @media screen and (max-width: 360px) {
        .title.is-massive { 
            font-size: 3.3rem;
            line-height: 3.2rem;
            margin-bottom: 0.5rem;
        }
    }
</style>